/**
 * HTML Message Templates API (NEX-2541).
 *
 * Frontend-facing client surface for per-EMBED-deployment HTML message
 * templates. Endpoint request/response shapes are the canonical Public API v1
 * schemas (`packages/types/src/api/public/v1/schemas/html-message-template.schemas.ts`)
 * so the generated `useNexusApi().htmlMessageTemplates` client and the backend
 * controllers validate against one source of truth.
 *
 * Paths target the INTERNAL Clerk-session-authed controller
 * (`@Controller("html-message-templates")`), prefixed with `/api` to match the
 * backend global mount point. The frontend authenticates with the Clerk
 * session, which the public api-key guard would reject — so this client points
 * at the internal controller, not `/api/public/v1/html-message-templates`.
 */

import { ApiSuccessSchema } from "../../common/response.schema";
import {
  CreateHtmlMessageTemplateBodySchema,
  DeleteHtmlMessageTemplateResponseSchema,
  FillHtmlMessageTemplateBodySchema,
  FillHtmlMessageTemplateResponseSchema,
  HtmlMessageTemplateIdParamSchema,
  HtmlMessageTemplateSchema,
  ListHtmlMessageTemplatesQuerySchema,
  ListHtmlMessageTemplatesResponseSchema,
  RenderHtmlMessageTemplateBodySchema,
  RenderHtmlMessageTemplateResponseSchema,
  UpdateHtmlMessageTemplateBodySchema
} from "../../public/v1/schemas/html-message-template.schemas";

const BASE = "/api/html-message-templates";
const PathTemplateId = HtmlMessageTemplateIdParamSchema;

export const ZHtmlMessageTemplates = {
  List: {
    method: "GET" as const,
    path: BASE,
    Query: ListHtmlMessageTemplatesQuerySchema,
    Response: ApiSuccessSchema(ListHtmlMessageTemplatesResponseSchema)
  },

  Get: {
    method: "GET" as const,
    path: `${BASE}/:templateId`,
    PathVars: PathTemplateId,
    Response: ApiSuccessSchema(HtmlMessageTemplateSchema)
  },

  Create: {
    method: "POST" as const,
    path: BASE,
    Body: CreateHtmlMessageTemplateBodySchema,
    Response: ApiSuccessSchema(HtmlMessageTemplateSchema)
  },

  Update: {
    method: "PATCH" as const,
    path: `${BASE}/:templateId`,
    PathVars: PathTemplateId,
    Body: UpdateHtmlMessageTemplateBodySchema,
    Response: ApiSuccessSchema(HtmlMessageTemplateSchema)
  },

  Delete: {
    method: "DELETE" as const,
    path: `${BASE}/:templateId`,
    PathVars: PathTemplateId,
    Response: ApiSuccessSchema(DeleteHtmlMessageTemplateResponseSchema)
  },

  Render: {
    method: "POST" as const,
    path: `${BASE}/:templateId/render`,
    PathVars: PathTemplateId,
    Body: RenderHtmlMessageTemplateBodySchema,
    Response: ApiSuccessSchema(RenderHtmlMessageTemplateResponseSchema)
  },

  Fill: {
    method: "POST" as const,
    path: `${BASE}/:templateId/fill`,
    PathVars: PathTemplateId,
    Body: FillHtmlMessageTemplateBodySchema,
    Response: ApiSuccessSchema(FillHtmlMessageTemplateResponseSchema)
  }
};
